export default ['tp-cat-fin', 'tp-cat-bus', 'tp-cat-marketing', 'tp-cat-web', 'tp-cat-design', 'tp-cat-img-aud', 'tp-cat-self-dev', 'tp-cat-lang', 'tp-cat-fitness', 'tp-cat-lifestyle'];
